// removed by extract-text-webpack-plugin
module.exports = {"container":"_1YAHGLlzLQVlRO35Sow_O3","option":"_3HsEcaYb3jJSrx0q0GSYhK"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Documents/Document/AdvancedSettings/Public/OwnerView/styles.css
// module id = 2826
// module chunks = 0